// extracted by mini-css-extract-plugin
module.exports = {"player":"RecordingField_player__LJpqf","upload":"RecordingField_upload__2HECP"};